import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { api } from '../api';
import { fetchToken } from '../auth/Token';
import { Box, Typography, Link, Button } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { toast } from 'sonner';

export default function CreateSharesNon(props) {
    const [share, setAllShare] = useState([]);
    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
      setOpen(false);
    };
    const handleOpen = () => {
      setOpen(true);
    };

    
    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      }));

          const allSharesAccounts = () =>{
            try{
              api.get("/account/share/hh", {
                headers: {
                  Authorization:'Bearer '+ fetchToken()
                }
              }).then(function (response) {
                setAllShare(response.data)
                console.log(share)
              })
    
            }catch (error){
              console.log('Here is the error '+error)
            }
          }
          
      useEffect(() => {
          allSharesAccounts();
      },[])

      const handleSave = (id) =>{
        handleOpen()
        const isAccountExist = props.accounts.some((item) => item.share_id === id);
        const iinfo = {
          'share_id': id,
          'association_member_id': props.Psb,
          'member_id': props.member_id
        }
        if(isAccountExist){
          handleClose()
          toast.error("Account already exist")
        }else{
          try {
            api.post('/account/membershare',iinfo, {
              headers: {
                Authorization: 'Bearer ' + fetchToken()
              }
            }).then(function (response){
              toast.success(response.data)
              props.fetchAccounts();
              handleClose();
              allSharesAccounts();
            })
          } catch (error) {
            console.log("Here is the error"+error)
          }
        }

      };


  return (
    <div>
        <Item>
            <Box>
              <Typography variant='h3'>Select Savings Account to Open</Typography>
            {share.map((savingItem, index) => (
                      <Link
                          sx={{ display:'flex' }}
                          key={index}
                          variant="h6"
                          underline="none"
                          component='button'
                          color="inherit"
                          onClick={() => handleSave(savingItem.id)}
                      >
                        
                          
                        <Typography variant='h5' sx={{ fontWeight:'600', color:'darkblue'}}>
                            {savingItem.account_name} (Share Value: GH₵{savingItem.share_value}.00)
                        </Typography>
                      </Link>
                      
                  ))}
            </Box>
            <Button variant='outlined' onClick={()=>props.setOpen_acc()}>Close</Button>
        </Item>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
    </div>
  )
}
